import React, { memo, useEffect, useState, useRef, useCallback } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs';
import { createSelector } from 'reselect';
import CardIndex from '../../card/CardIndex/CardIndex';
import styles from './NSpecial.module.less';
import { logging } from '../../actions/log';
import Toast from '../../components/Toast/Toast';
import Overview from './Overview';
import { useHistory } from 'react-router-dom';
import { CONTEXT } from '../../config';
// import CommentList from '../../components/Comment/CommentList';
// import Comment from '../../components/Comment/Comment';
import useLoginStatus from '../../utils/hooks/useLoginStatus';
import { useInView } from 'react-intersection-observer';
import TopImgVideo from '../../components/TopImgVideo/TopImgVideo';
import config from './config';
import { logNative } from '../../utils/utils';
import { handleLogin } from '../../utils/hooks/useLoginStatus';
import Comment from '../../components/Comment/Comment';
import { useUnactivate } from 'react-activation';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(
  ({ specialInfo = {}, bannerId, viewPage, ztId, bizInfo, getSpecialInfo, updateSpecialInfo }) => {
    const [zan, setZan] = useState(false);
    const [zanNum, setZanNum] = useState(0);
    const [isCollect, setIsCollect] = useState(false); // 是否有正在提交的收藏
    const loginStatus = useLoginStatus();
    const [collectPosition, setCollectPosition] = useState('top');
    const logInfoData = useSelector(selectLogInfo);
    const dispatch = useDispatch();
    const history = useHistory();
    const init = useRef(null);
    const node = useRef(null);
    const [recommZT, setRecommZT] = useState([]);
    const [updateCommentData, setUpdateCommentData] = useState(null);

    // 收藏专题 或则取消专题
    const handleSpecialCollect = async () => {
      setIsCollect(true);
      if (!loginStatus) {
        // 调用登陆
        handleLogin(); // 未登录 调用登录弹窗
        return;
      }
      setIsCollect(false);
      if (!specialInfo.hasCollect) {
        const data = await config.addCollectSpecial(
          {
            targetId: specialInfo.ztId,
            targetType: 'zt',
          },
          specialInfo,
        );
        updateSpecialInfo(data);
        dispatch(
          logging({
            category: 'C',
            action: 'Special_Collect',
            label: '',
            param2: {
              source: `Special||${specialInfo.ztId || ''}||${bannerId || ''}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              type: collectPosition, // 收藏点击位置
            },
            param3: bizInfo,
          }),
        );
      } else {
        const data = await config.deleteCollectSpecial(
          {
            targetId: specialInfo.ztId,
            targetType: 'zt',
          },
          specialInfo,
        );
        updateSpecialInfo(data);
        dispatch(
          logging({
            category: 'C',
            action: 'Mysofts_Collect_Cancel',
            label: '',
            param2: {
              source: `Special||${specialInfo.ztId || ''}||${bannerId || ''}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              softid: specialInfo && specialInfo.ztId,
              softtype: 'zt',
              type: collectPosition, // 收藏点击位置
            },
            param3: bizInfo,
          }),
        );
      }
    };

    useEffect(() => {
      if (loginStatus && isCollect) {
        handleSpecialCollect();
      }
    }, [loginStatus, isCollect]);

    useEffect(() => {
      setZanNum(specialInfo.zanCount);
      setZan(specialInfo.hasZan === 1);
    }, [specialInfo]);

    const handleZan = source => async () => {
      if (zan) {
        Toast.error({
          content: <div className={styles.toast}>已赞过该专题</div>,
          className: styles.toast_img,
        });
        return;
      }
      setZan(true);
      const data = await config.setSpecialZan(
        {
          type: 2,
          ztId: specialInfo.ztId,
        },
        specialInfo,
      );
      updateSpecialInfo(data);
      // 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Special_Zan',
          label: '',
          param2: {
            source: `Special||${specialInfo.ztId || ''}||${bannerId || ''}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            type: source,
          },
          param3: bizInfo,
        }),
      );
    };

    const handleNumber = (data = 0) => {
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(+data)) {
        return data;
      }
      if (+data < 1000) {
        return data;
      }
      if (+data < 10000) {
        return `${(data / 1000).toFixed(1)}k`;
      }

      return `${(data / 10000).toFixed(1)}w`;
    };

    const handleTag =
      (tag = {}) =>
      () => {
        dispatch(
          logging({
            category: 'C',
            action: 'Special_Classify',
            label: '',
            param2: {
              source: `Special||${specialInfo.ztId || ''}||${bannerId || ''}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              softid: specialInfo.ztId,
              type: tag.tagId,
            },
            param3: bizInfo,
          }),
        );
        history.push(
          `${CONTEXT}/speciallist?pageType=special&ztType=${'all'}&tag=${tag.tagId || ''}`,
        );
      };

    const getRecommZt = useCallback(async () => {
      try {
        const data = await config.getSpecialListBySource({
          pageType: 'special',
          ztType: specialInfo.ztType,
          ztId: specialInfo.ztId,
        });
        setRecommZT(data);
      } catch (err) {
        logNative(`获取推荐专题列表出错${err}`);
      }
    }, [specialInfo]);

    const handelCommentOnData = useCallback(data => {
      setUpdateCommentData(data);
    }, []);

    useEffect(() => {
      if (specialInfo?.ztId) {
        getRecommZt();
      }
    }, [specialInfo]);

    return (
      <>
        <div className={styles.special_top}>
          <TopImgVideo
            data={{ img: specialInfo.ztHeadBig || specialInfo.ztHead }}
            page="special"
            node={node.current}
          />
        </div>

        <div className={styles.nspecial} ref={node} pagescroll="PCStore_Page_Scroll">
          <div className={styles.nspecial_container}>
            <div className={styles.nspecial_header}>
              <div className={styles.nspecial_header_content}>
                <div className={styles.nspecial_header_title}>{specialInfo.ztTitle}</div>
                <div className={styles.nspecial_header_icon}>
                  <div className={classNames(styles.nspecial_header_time)}>
                    {specialInfo.pushTime && dayjs(specialInfo.pushTime).format('YYYY/MM/DD')}
                  </div>
                  <div className={classNames(styles.nspecial_header_icon_single)}>
                    <div className={classNames(styles.icon_zan)}>
                      <i
                        className={classNames('iconfont icon-reads')}
                        style={{ position: 'relative', top: '1px' }}
                      />
                    </div>
                    <span>{handleNumber(specialInfo.watchCount)}</span>
                  </div>
                  <div
                    className={classNames(
                      styles.nspecial_header_icon_single,
                      styles.nspecial_header_icon_active,
                    )}
                    onClick={handleZan('top')}
                  >
                    <div
                      className={classNames(styles.icon_zan, { [styles.icon_zan_active]: true })}
                    >
                      <i
                        className={classNames(`iconfont ${zan ? 'icon-zaned' : 'icon-zan'}`)}
                        style={{ position: 'relative', top: '1px' }}
                      />
                    </div>
                    <span className={styles.text_zan}>{handleNumber(zanNum)}</span>
                  </div>
                  <div
                    className={classNames(
                      styles.nspecial_header_icon_single,
                      styles.nspecial_header_icon_active,
                    )}
                    onClick={() => {
                      setCollectPosition('top');
                      handleSpecialCollect();
                    }}
                  >
                    <div
                      className={classNames(styles.icon_zan, { [styles.icon_zan_active]: true })}
                    >
                      <i
                        className={classNames(
                          `iconfont ${specialInfo.hasCollect ? 'icon-collected' : 'icon-collect'}`,
                          styles.icon_collect,
                        )}
                      />
                    </div>
                    <span className={styles.text_zan}>收藏</span>
                  </div>
                </div>

                <div
                  className={styles.nspecial_header_desc}
                  dangerouslySetInnerHTML={{ __html: specialInfo.ztLongDesc }}
                />
              </div>
            </div>
            <div className={styles.nspecial_content}>
              {specialInfo &&
                specialInfo.ztList &&
                specialInfo.ztList.slice(1).map((item, i) => (
                  <React.Fragment key={i}>
                    <CardIndex data={item} key={i} logInfo={{ tag: 'Special' }} />
                  </React.Fragment>
                ))}
            </div>
            {specialInfo && specialInfo.tags && specialInfo.tags.length > 0 && (
              <div className={styles.nspecial_tag}>
                <div className={styles.nspecial_tag_label}>专题标签：</div>
                {specialInfo.tags.map((item, index) => (
                  <div
                    className={styles.nspecial_tag_item}
                    key={`${index}_${item.tagId}`}
                    onClick={handleTag(item)}
                  >
                    {item.tagName}
                  </div>
                ))}
              </div>
            )}
            {specialInfo &&
              specialInfo.ztId &&
              specialInfo.ztType &&
              recommZT &&
              recommZT.map((item, index) => {
                return (
                  <CardIndex
                    data={{ ...item, ztType: specialInfo.ztType || '' }}
                    key={index}
                    logInfo={{ tag: 'Special' }}
                  />
                );
              })}

            <div className={styles.comment}>
              <Comment
                data={{
                  type: '2',
                  // app: appDetailsData,
                  bizIdentity: `zt_${specialInfo?.ztId}`,
                  // tagCode: appDetailsData?.lenovoClassId,
                }}
                scrollEl={node.current}
                hasCommentOn={false}
                updateCommentData={updateCommentData}
                commentTargetInfo={{
                  targetId: specialInfo?.ztId,
                  targetName: specialInfo?.ztTitle,
                  targetCategoryCode: specialInfo?.tags?.map(item => item.tagId),
                }}
              />
            </div>
          </div>
          {
            <Overview
              specialInfo={specialInfo}
              zan={zan}
              handel={{
                collect: () => {
                  setCollectPosition('suspen');
                  handleSpecialCollect();
                },
                zan: handleZan('suspen'),
              }}
              handelCommentOnData={handelCommentOnData}
              scrollEl={node.current}
            />
          }
        </div>
      </>
    );
  },
);
